 import axios, { AxiosResponse } from 'axios';
import { jwtDecode } from 'jwt-decode';
import Cookies from 'js-cookie';

const BASE_URL = process.env.REACT_APP_BASE_URL;
export const sbwcHomPage = process.env.REACT_APP_SBWC_HOME_PAGE;
export const paymentsHomPage = process.env.REACT_APP_PAYMENTS_HOME_PAGE;
interface tokenResponse {
    token: string;
    tokenExpiration: string;
}
class AnnualAssessmentPaymentService {
    async annualAssementPayment(paymentRequest: any): Promise<any> {
        try {
           
            // Step 1: Generate the token by making the first API call
            const tokenResponse = await axios.post<tokenResponse>(`${BASE_URL}/token/generatetoken`,
                paymentRequest);
            const decodedToken: any = jwtDecode(tokenResponse.data.token);
          
            localStorage.setItem("paymentToken", tokenResponse.data.token);
            localStorage.setItem("paymentTokenExpiration", tokenResponse.data.tokenExpiration);
            // If the first API call is successful, then call the second one using the token
            if (tokenResponse && tokenResponse.data) {
                // Step 2: Make the request to the annual assessment payment endpoint with the token
                const paymentResponse = await axios.post(
                    `${BASE_URL}/annualassementpayment`,
                    paymentRequest,
                    {
                        headers: {
                            Authorization: `Bearer ${tokenResponse.data.token}`,  // Assuming token is returned in 'token' field
                        }
                    }
                );

                return paymentResponse.data;  // Return the response data from the second call
            } else {
                throw new Error('Token generation failed');
            }
        } catch (error) {
            return Promise.reject(error);  // Reject the promise in case of error
        }
    }
    async refreshToken(invoiceNumber: any, referenceNumber: any): Promise<any> {
        try {
            const token = localStorage.getItem("paymentToken");
            if (token && invoiceNumber && referenceNumber) {
                const refreshResponse = await axios.post<tokenResponse>(
                    `${BASE_URL}/token/refreshtoken`,
                    {
                        token: token,
                        invoiceNumber: invoiceNumber,
                        referenceNumber: referenceNumber,
                    },
                    {
                        headers: {
                            Authorization: `Bearer ${token}`,
                        }
                    }
                );
                localStorage.setItem("paymentToken", refreshResponse.data.token);
                localStorage.setItem("paymentTokenExpiration", refreshResponse.data.tokenExpiration);
                return refreshResponse;
            }
        } catch (error) {
            console.error('Error refreshing token:', error);
            throw new Error('Token refresh failed');
        }
    }

    async getPaymentDetails(): Promise<any> {
        try {
           
            const token = Cookies.get('authToken');
           
        if (!token) throw new Error('No token found');
           
            const response = await axios.get<any>(`${BASE_URL}/getAnnualAssessmentPaymentInformation`, {
                // Convert array to comma-separated string
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });
           
            return response.data;
        } catch (error) {
            console.error('Error refreshing token:', error);
            throw error;
        }

    }
async getPaymentRequest(email: string, paymentMethod: string, outStandingAmount: string): Promise<any> {
    try {
       
        const token = localStorage.getItem("paymentToken");

        if (!token) throw new Error('No token found');

        const response = await axios.get<any>(`${BASE_URL}/getAnnualAssessmentPaymentRequestInformation`, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
            params: {
                email: email,
                paymentMethod: paymentMethod,
                outStandingAmount: outStandingAmount
            }
        });

        return response.data;
    } catch (error) {
        throw error;
    }
}


}


export default new AnnualAssessmentPaymentService();
